import { ASK_AI_TYPES } from '../../constants'
import { createPortal } from 'react-dom'
import Button from '../Buttons'
import {
	LuBolt,
	LuCircleCheckBig,
	LuFileText,
	LuAtSign,
	LuScissors,
	LuMessageCircleDashed,
	LuCheck,
} from 'react-icons/lu'
import { useFeatureFlagVariantKey, usePostHog } from 'posthog-js/react'
import { FEATURE_FLAGS } from '../../hooks/featureFlags'
import { useMemo } from 'react'
import useIsPremium from '../../hooks/useIsPremium'

const typesToIcons = {
	'Fix Grammar': LuCircleCheckBig,
	Improve: LuBolt,
	Simplify: LuFileText,
	Shorten: LuScissors,
	Cite: LuAtSign,
	Customize: LuMessageCircleDashed,
}

const EditorBar = ({
	onEditButtonClick,
	onCompleteClick,
}: {
	onEditButtonClick: (e: any, options: { type?: string; prompt?: string }) => void
	onCompleteClick: () => void
}) => {
	const isPremium = useIsPremium()
	const showCompleteButton = useFeatureFlagVariantKey(FEATURE_FLAGS.SHOW_COMPLETE_BUTTON)
	const posthog = usePostHog()
	const addSentenceReferenceFF = useFeatureFlagVariantKey(FEATURE_FLAGS.SENTENCE_REFERENCE)

	const _showCompleteButton = false

	const options = useMemo(() => {
		return Object.entries(ASK_AI_TYPES).filter(([key]) => key !== 'shorten')
	}, [])

	return createPortal(
		<div className="fixed bottom-0 left-0 right-0 bg-white px-4 py-3 overflow-x-auto w-screen gap-2 flex justify-center">
			<div
				className={`flex items-center gap-2 w-full max-w-6xl ${
					_showCompleteButton ? 'md:justify-between' : 'md:justify-center'
				}`}
			>
				<div className={`flex items-center gap-2 ${_showCompleteButton ? 'md:justify-start' : 'md:justify-center'}`}>
					<Button
						type="outline"
						className="md:text-base text-sm items-center whitespace-nowrap"
						onClick={(e) => {
							onEditButtonClick(e, { type: 'Customize' })
							posthog.capture('editor-bar-cite-click')
						}}
					>
						{typesToIcons['Customize']({ className: 'inline-block mr-2 inline-block' })}
						Customize
					</Button>
					{addSentenceReferenceFF === 'test' && (
						<Button
							type="outline"
							className={`md:text-base text-sm items-center whitespace-nowrap`}
							onClick={(e) => {
								onEditButtonClick(e, { type: 'Cite' })
								posthog.capture('editor-bar-cite-click')
							}}
						>
							{typesToIcons['Cite']({ className: 'inline-block mr-2 inline-block' })}
							Find References
						</Button>
					)}
					{options.map(([key, value]) => {
						return (
							<Button
								type="outline"
								key={key + value}
								onClick={(e) => onEditButtonClick(e, { type: value })}
								className="md:text-base text-sm items-center whitespace-nowrap"
							>
								{
									// @ts-ignore
									typesToIcons[value as keyof typeof typesToIcons]({
										className: 'inline-block mr-2 inline-block',
									})
								}
								{value}
							</Button>
						)
					})}
				</div>
				{_showCompleteButton && (
					<Button
						type="default"
						className="md:text-base text-sm items-center whitespace-nowrap md:block hidden"
						onClick={() => {
							onCompleteClick()
							posthog.capture('complete-essay-click')
						}}
					>
						{LuCheck({ className: 'inline-block mr-2 inline-block' })}
						Complete essay
					</Button>
				)}
			</div>
		</div>,
		document.body
	)
}

export default EditorBar
